module.exports = __webpack_public_path__ + "img/nos-new.84182563.jpeg";